// This function was moved out of util.js to avoid a circular dependency between it and validator-worker
// If the worker is replaced with a fetch, but you still want to encapsulate logic in a util function
// consider moving this back into util.

export default function (geometry, abortController, maxVertexCount = 500) {
  const worker = new Worker(new URL('./validator-worker.js', import.meta.url), {
    type: 'module',
  });

  const workerPromise = new Promise((resolve, reject) => {
    worker.onmessage = ({data: {type, ...data}}) => {
      resolve(data);
    };

    worker.onerror = () => {
      reject();
    };
  });

  if (abortController) {
    abortController.signal.addEventListener('abort', () => {
      worker.terminate();
    });
  }
  worker.postMessage({geometry, maxVertexCount});
  return workerPromise;
}
